/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-extraneous-dependencies */
import { useNamespace, useOkapiKy } from '@folio/stripes-core';
import { useQuery } from '@tanstack/react-query';

function useReport(reportId) {
  const okapiKy = useOkapiKy();
  const [namespace] = useNamespace({ key: 'reports' });

  const {
    isLoading,
    isError,
    data = {},
    refetch,
    ...rest
  } = useQuery({
    queryKey: [namespace, reportId],
    queryFn: () =>
      okapiKy
        .get(reportId ? `reports/${reportId}` : 'reports?limit=2147483647')
        .json(),
    enabled: reportId ? Boolean(reportId) : true,
  });

  return {
    isLoading,
    isError,
    reports: reportId ? data : data.reports,
    refetch,
    rest,
  };
}

export default useReport;
